export class DocumentDto{
    file: File;
    fileName: string;
    fileDescription: string = '';
    link : string ='';
    customField: string = "";
}